import { themeProvider } from '@swipejobs/frontend-theme-provider';
import styled from 'styled-components';

export const LoaderContainer = styled.div`
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  bottom: 0;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
`;

export const LoaderBox = styled.div`
  background-color: rgba(0, 0, 0, 0.7);
  padding: 20px;
  border-radius: 5px;
  max-width: 150px;
`;

export const LoaderMessage = styled.span`
  color: ${() => themeProvider.getColors().text.primaryTextColor};
  margin-top: 10px;
  max-width: 150px;
  text-align: center;
`;



// WEBPACK FOOTER //
// ./src/components/loader/styles.tsx